import request from '@/utils/request'
import { feedbackHost,monitorHost,gameHost,draftHost } from './index'

const host = window.location.host
const protocol = window.location.protocol + '//'
let baseHost = protocol + 'study.test.classba.cn'

switch (host) {
  case 'study.171xue.com':
  case 'study.classba.cn':
    baseHost = protocol + 'study.classba.cn'
    break
  case 'study-pre.classba.cn':
    baseHost = protocol + 'study-pre.classba.cn'
    break
  default:
    break
}

const BASE_URL = baseHost + '/api'
const checkVideoUrl = '//check-video.classba.cn/'

const isProduction = !window.location.host.includes('test');
const MBASE_URL = isProduction
  ? 'https://paducenter-api.classba.cn'
  : 'https://paducenter-api-test.classba.cn'; // 测试环境
  // 获取校区logo
 const  getChannelInfo = params => {
    return request({
      url: `${MBASE_URL}/school/getChannelInfo`,
      method: 'post',
      data: params,
    });
  }

const prelogin = data => {
  return request({
    url: BASE_URL + "/login",
    method: "post",
    data
  });
};

const login = data => {
  return request({
    url: BASE_URL+ '/getlogininfo',
    method: 'post',
    data
  })
}

const nextStep = data => {
  return request({
    url: BASE_URL + '/go',
    method: 'post',
    data
  })
}

// 提交答案
const submitEvent = data => {
  return request({
    url: BASE_URL + '/submit',
    method: 'post',
    data
  })
}

// 获取题目答案
const getQuestionAnalyze = data => {
  return request({
    url: BASE_URL + '/analyze',
    method: 'post'
  })
}

// 试做获取题目数据byUuid
const getQuestionByUuid = data => {
  return request({
    url: BASE_URL + '/getquestion',
    method: 'post',
    data
  })
}

// 试做提交答案
const submitEventQuestion = data => {
  return request({
    url: BASE_URL + '/submitquestion',
    method: 'post',
    data
  })
}
// 获取结果页
const getResult = data => {
  return request({
    url: BASE_URL + '/result',
    method: 'post',
    data
  })
}

// 获取游戏化信息
const normalInfo = data => {
  return request({
    url: gameHost + '/user/normalInfo',
    method: 'post',
    data
  })
}

const submitError = data => {
  return request({
    url: BASE_URL + '/math/event/submitError',
    method: 'post',
    data
  })
}

const selfappraisal = data => {
  return request({
    url: BASE_URL + '/selfappraisal',
    method: 'post',
    data
  })
}

const getTransitionReport = data => {
  return request({
    url: BASE_URL + '/math/report/getTransitionReport',
    method: 'post',
    data
  })
}

const submitGuideEnmu = data => {
  return request({
    url: BASE_URL + '/math/event/submitGuideEnmu',
    method: 'post',
    data
  })
}

const checkVideo = url => {
  return request({
    baseURL: checkVideoUrl,
    url: 'video_m3u8.php?u=' + encodeURIComponent(url)
  })
}

const checkCompareApi = data => {
  return request({
    baseURL: BASE_URL + '/math/report/checkCompare',
    method: 'post',
    data
  })
}

const applyLessonTime = data => {
  return request({
    url: BASE_URL + '/applyclasshour',
    method: 'post',
    data
  })
}

const feedBack = data => {
  return request({
    url: feedbackHost + '/api/feedback',
    method: 'post',
    data
  })
}


const getQuestionByTagCode = data => {
  return request({
    url: feedbackHost + '/api/getQuestionByTagCode',
    method: 'post',
    data
  })
}

const getErrorReason = data => {
  return request({
    url: feedbackHost + '/api/getErrorReason',
    method: 'post',
    data
  })
}

const getFeedbackDetail = data => {
  return request({
    url: feedbackHost + '/api/getFeedbackDetail',
    method: 'post',
    data
  })
}

const getGraspTagCode = data => {
  return request({
    url: feedbackHost + '/api/getGraspTagCode',
    method: 'post',
    data
  })
}

const getAllQuestion = data => {
  return request({
    url: curDetailUrl + 'daily/detail',
    // url: 'http://mphys.test.classba.cn/api/mphy/report/getModuleQuestionList',
    method: 'post',
    data
  })
}

const getQuestionList = data => {
  return request({
    url: './data.json',
    // url: 'http://mphys.test.classba.cn/api/mphy/report/getModuleQuestionList',
    method: 'get',
    data
  })
}

const getTagCodeList = data => {
  return request({
    url: 'http://mphys.test.classba.cn/api/mphy/report/getTagCodeList',
    method: 'post',
    data
  })
}

const getAddCrystal = data => {
  return request({
    url: feedbackHost + '/game/embrave/notify',
    // url: 'http://game-api.test.classba.cn/embrave/notify',
    method: 'post',
    data
  })
}

const getUserTag = data => {
  return request({
    url: '/api/getUserTag',
    method: 'post',
    data
  })
}

const heartBeat = data => {
  return request({
    url: monitorHost + '/heartBeat',
    method: 'post',
    data
  })
}

const getBoardImgAction = data => { // 获取手写板图片
  return request({
    baseURL: draftHost + `/client/getBoardImg`,
    method: 'post',
    data
  })
}

const getBoardImgsAction = data => { // 批量获取手写板图片
  return request({
    baseURL: draftHost + `/client/getBoardImgs`,
    method: 'post',
    data
  })
}

const setBoardGuideAction = data => {
  return request({
    baseURL: draftHost + `/client/setBoardGuide`,
    method: 'post',
    data
  })
}
const getBoardGuideAction = data => {
  return request({
    baseURL: draftHost + `/client/getBoardGuide`,
    method: 'post',
    data
  })
}

export {
  getChannelInfo,
  prelogin,
  login,
  nextStep,
  submitEvent,
  getQuestionAnalyze,
  submitEventQuestion,
  getQuestionByUuid,
  getResult,

  submitError,
  selfappraisal,
  getTransitionReport,
  submitGuideEnmu,
  checkVideo,
  checkCompareApi,
  applyLessonTime,

  feedBack,
  getQuestionByTagCode,
  getErrorReason,
  getFeedbackDetail,
  getGraspTagCode,
  normalInfo,

  getAllQuestion,
  getTagCodeList,
  getQuestionList,

  getAddCrystal,
  getUserTag,
  heartBeat,

  getBoardImgAction,
  setBoardGuideAction,
  getBoardGuideAction,
  getBoardImgsAction,
}



// WEBPACK FOOTER //
// ./src/api/base.js